import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/home.png'
import _imports_1 from '@/assets/sucess-img.png'
import _imports_2 from '@/assets/notice.png'


const _withScopeId = n => (_pushScopeId("data-v-9641e40c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "physical-sucess" }
const _hoisted_2 = { class: "physical-info" }
const _hoisted_3 = { class: "physical-info-head" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "physical-icon",
  src: _imports_1
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "physical-status" }, "体检预约已完成", -1))
const _hoisted_6 = { class: "form-list" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "机构名称", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "体检人姓名", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "体检日期", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "机构地址", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "notice-img",
  src: _imports_2
}, null, -1))
const _hoisted_12 = { class: "notice" }

import { computed, onMounted, reactive, ref } from 'vue';
    import { Toast } from 'vant';
    import tabbar from "src/components/common/tabbar";
    import dayjs from 'dayjs';
    import { PhysicalService } from 'src/services';
    import {useToken } from 'src/store';
    import { useRouter, useRoute } from 'vue-router';
    import UpageList from 'src/components/common/page-list';
    import PageBack from 'src/components/common/page-back';
    import uScheduling from 'src/components/common/scheduling';
    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const { setAccessToken, setRefreshToken } = useToken();
    const router = useRouter();
    const route = useRoute();

    let $pageList = ref(null)
    let key = ref("")
    let showOverlay = ref(false)
    let showChangeOverlay = ref(false)
    let showDate = ref(false)
    const activeNames = ref([]);

    let detailInfo = ref({
        id: null,
        statusStr: "",
        memberName:"",
        invalidateTime:"",
        memberSexStr: "",
        policyNumbers: [],
        active: false,
        status: 1,
        physicalInfo:{
            hospitalId:0,
            packageId: 0,
            physicalItems:{},
            hospitalName: "",
            fullAddress: "",
            physicalDate: "",
            precautions:"",
            itemPrecautions: []
        }
    })

    onMounted(()=>
    {
        if(route.query.id)
        {
            getphysicalDetail(route.query.id)
        }
    })

    /**
     * 获取体检任务 
     */
    let getphysicalDetail = async (id)=>
    {
        try {
            let { content: res } = await PhysicalService.instance.getphysicalDetail(id);
            if(res.data)
            {
                detailInfo.value = res.data;
            }
        } catch (err) {
            Toast(err);
        }
    }

    /**
     * 获取体检任务 
     */
    let formatDate = (day)=>
    {
        return dayjs(day).format("YYYY/MM/DD")
    }

    /**
     * 取消 
     */
    let cancelReserve = async ()=>
    {
        try {
            let { content: res } = await PhysicalService.instance.cancelReserve(detailInfo.value.id);
            Toast("取消成功")
            showOverlay.value = false;
            getphysicalDetail(detailInfo.value.id)
        } catch (err) {
            Toast(err);
        }
    }

    /**
     * 搜索 
     */
    let onSearch = (parameter)=>
    {
        $pageList.value.onRefresh()
    }

    /**
     * 跳转首页 
     */
    let goHome = ()=>
    {
        router.push({name: "home"});
    }

    /**
     * 确认日期 
     */
    let onDateConfirm = async (date)=>
    {
        try
        {
            await PhysicalService.instance.changeReserve({
                id: detailInfo.value.id,
                hospitalId: detailInfo.value.physicalInfo.hospitalId,
                hospitalName: detailInfo.value.physicalInfo.hospitalName,
                physicalDate: date
            })
            getphysicalDetail(detailInfo.value.id);
            showChangeOverlay.value = true;
        }
        catch(err)
        {
            Toast(err)
        }
    }
    

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_unref(route).query && _unref(route).query.type)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "physical-home",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(goHome) && _unref(goHome)(...args))),
              src: _imports_0
            }))
          : _createCommentVNode("", true),
        _hoisted_4,
        _hoisted_5
      ]),
      _createElementVNode("ul", _hoisted_6, [
        _createElementVNode("li", null, [
          _hoisted_7,
          _createElementVNode("div", null, _toDisplayString(_unref(detailInfo).physicalInfo && _unref(detailInfo).physicalInfo.hospitalName), 1)
        ]),
        _createElementVNode("li", null, [
          _hoisted_8,
          _createElementVNode("div", null, _toDisplayString(_unref(detailInfo).memberName), 1)
        ]),
        _createElementVNode("li", null, [
          _hoisted_9,
          _createElementVNode("div", null, _toDisplayString(_unref(detailInfo).physicalInfo && _unref(formatDate)(_unref(detailInfo).physicalInfo.physicalDate)), 1)
        ]),
        _createElementVNode("li", null, [
          _hoisted_10,
          _createElementVNode("div", null, _toDisplayString(_unref(detailInfo).physicalInfo && _unref(detailInfo).physicalInfo.fullAddress), 1)
        ])
      ])
    ]),
    _hoisted_11,
    _createElementVNode("div", _hoisted_12, [
      (_unref(detailInfo).physicalInfo && _unref(detailInfo).physicalInfo.itemPrecautions.length)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(detailInfo).physicalInfo.itemPrecautions, (precaution, index) => {
            return (_openBlock(), _createElementBlock("p", null, _toDisplayString(`${index+1}. ${precaution}`), 1))
          }), 256))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})